module.exports = __webpack_public_path__ + "img/sample2.25c7a0c2.jpg";